export const SQLiteViewConfig = Symbol.for('drizzle:SQLiteViewConfig');
